<template>
  <div class="login">
    <div class="login_box">
      <h1>环境监测系统</h1>
      <div class="login_logo">
        <i class="el-icon-user-solid"></i>
      </div>
      <div class="login_input clearfix">
        <span class="fl">
          <i class="el-icon-s-custom"></i>
          账号：
        </span>
        <input class="fl" type="text" v-model="account" />
      </div>
      <div class="login_input clearfix">
        <span class="fl">
          <i class="el-icon-s-help"></i>
          密码：
        </span>
        <input class="fl" type="password" v-model="password" />
      </div>
      <div class="login_btn">
        <el-button type="primary" @click="loginBtn()">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      account: "",
      password: "",
      // account: "jjszadmin",
      // password: "jjsz12345",
    };
  },
  created() {
    // this.loginBtn();
    // console.log(this.api);
  },
  methods: {
    //   登录
    loginBtn() {
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DoLogin",
          loginID: this.account,
          loginPD: this.password,
        },
      })
        .then((res) => {
          console.log(res, "login");
          if (res.data._STATUS == "0") {
            this.$message({
              type: "success",
              message: "登录成功",
            });
            // 获取Tab菜单结构
            let menus = res.data.menus;
            // 处理Tab菜单结构
            let arr1 = [];
            let arr2 = [];
            let arr3 = [];
            for (let i = 0; i < menus.length; i++) {
              if (menus[i].level == 3) {
                arr3.push({
                  menuId: menus[i].menuId,
                  menuName: menus[i].menuName,
                  parentId: menus[i].parentId,
                  txcode: menus[i].txcode,
                });
              }
              if (menus[i].level == 1) {
                if (menus[i].menuName !== "修改密码") {
                  arr1.push({
                    menuId: menus[i].menuId,
                    menuName: menus[i].menuName,
                    parentId: menus[i].parentId,
                    txcode: menus[i].txcode,
                    list: [],
                  });
                }
              }
              if (menus[i].level == 2) {
                if (menus[i].txcode !== "") {
                  arr2.push({
                    menuId: menus[i].menuId,
                    menuName: menus[i].menuName,
                    parentId: menus[i].parentId,
                    txcode: menus[i].txcode,
                  });
                }
              }
            }
            for (let i = 0; i < arr1.length; i++) {
              (function (i) {
                for (let j = 0; j < arr2.length; j++) {
                  if (arr1[i].menuId == arr2[j].parentId) {
                    arr1[i].list.push(arr2[j]);
                  }
                }
              })(i);
            }

            for (let i = 0; i < arr1.length; i++) {
              if (arr1[i].list.length == 0) {
                arr1.splice(i, 1);
                i--;
              }
            }

            if (arr3.length > 0) {
              for (let i = 0; i < arr1.length; i++) {
                if (arr1[i].menuName == "系统管理") {
                  for (let j = 0; j < arr3.length; j++) {
                    arr1[i].list.push(arr3[j]);
                  }
                  break;
                }
              }
            }

            // vuex存储数据 -存储Tab菜单结构
            this.$store.commit("getList", arr1);

            // 存储Tab菜单结构
            let institutionsTree = JSON.stringify(arr1);

            // 登录 loginToken
            let loginToken = res.data.loginToken;
            // 机构名称
            let deptName = res.data.deptName;
            // 用户名称
            let userName = res.data.userName;
            // 用户ID
            let deptId = res.data._deptId;
            // 用户账号
            let loginID = res.data.loginID;

            // logo相对路径
            let deptPhotoPath = res.data.deptPhotoPath;
            // logo
            let deptLogo = res.data.deptLogo;
            // 中心主图
            let deptPhoto = res.data.deptPhoto;

            let dataItemsList = [];
            for (let i = 0; i < res.data.dataItems.length; i++) {
              dataItemsList.push({
                value: res.data.dataItems[i].dataName,
                keys: "data" + res.data.dataItems[i].dataId.slice(-2),
                dataId: res.data.dataItems[i].dataId,
              });
            }
            let dataItems = JSON.stringify(dataItemsList);
            localStorage.setItem("dataItems", dataItems);

            localStorage.setItem("institutionsTree", institutionsTree);
            localStorage.setItem("loginID", loginID);
            localStorage.setItem("loginToken", loginToken);
            localStorage.setItem("deptName", deptName);
            localStorage.setItem("userName", userName);
            localStorage.setItem("deptId", deptId);
            localStorage.setItem("deptPhotoPath", deptPhotoPath);
            localStorage.setItem("deptLogo", deptLogo);
            localStorage.setItem("deptPhoto", deptPhoto);

            // 登录成功后跳转
            this.$router.push("/index");
          } else {
            this.$message({
              message: res.data._ERROR,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #ccc;
  background: url("../assets/img/login.jpg") no-repeat;
  background-size: 100% 100%;
  .login_box {
    position: absolute;
    left: calc(50% - 250px);
    top: calc(50% - 280px);
    width: 500px;
    height: 450px;
    border-radius: 10px;
    background-color: rgba(242, 242, 242, 0.2);
    h1 {
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-weight: bold;
      font-size: 20px;
      letter-spacing: 6px;
      color: #fff;
      text-shadow: #000 0 0 1px;
      border-bottom: 2px solid #ddd;
      text-align: center;
    }
    .login_logo {
      width: 80px;
      height: 80px;
      margin: 20px auto;
      border-radius: 50%;
      border: 2px solid #ddd;
      // background-color: #ccc;
      text-align: center;
      line-height: 80px;
      color: #fff;
      font-size: 38px;
    }
    .login_input {
      width: 80%;
      margin: 25px auto;
      box-sizing: border-box;
      display: flex;
      text-shadow: #000 0 0 1px;
      color: #fff;
      justify-content: center;
      span {
        padding: 0 15px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #fff;
        border-right: none;
        text-align: right;
      }
      input {
        width: 220px;
        height: 40px;
        font-size: 18px;
        color: #fff;
        padding: 0 10px;
        background-color: transparent;
        border: 1px solid #fff;
      }
    }
    .login_btn {
      width: 100%;
      text-align: center;
      margin-top: 50px;
      .el-button {
        width: 68%;
      }
    }
  }
}
</style>